/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        version="1.1"
        fill="currentColor"
        className={classNames('nmx-icon nmx-icon-circle-with-person', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M16.83,8.52A8.33,8.33,0,1,0,8.5,16.83,8.32,8.32,0,0,0,16.83,8.52ZM8.5,16a7.37,7.37,0,0,1-5.4-2.32c.06-1.15.24-1.53.83-1.84a11.22,11.22,0,0,1,4.64-1,11.1,11.1,0,0,1,4.58,1c.57.3.75.68.82,1.76A7.43,7.43,0,0,1,8.5,16ZM6.27,6.4a2.23,2.23,0,0,1,4.46,0c0,1.34-.79,3.28-2.23,3.28S6.27,7.74,6.27,6.4ZM13.55,11a11.33,11.33,0,0,0-3.56-1A4.79,4.79,0,0,0,11.6,6.4a3.11,3.11,0,1,0-6.21,0A4.76,4.76,0,0,0,7,10.05a11.39,11.39,0,0,0-3.49,1,2.16,2.16,0,0,0-1.21,1.65A7.35,7.35,0,0,1,1.05,8.52a7.45,7.45,0,0,1,14.9,0,7.23,7.23,0,0,1-1.22,4.06A2.12,2.12,0,0,0,13.55,11Z"
          transform="translate(-0.17 -0.17)"
          className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'CircleWithPersonIcon';

export default Icon;
